import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-user",
  "use": "icon-user-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" class=\"icon\" id=\"icon-user\">\r\n  <path id=\"icon-user_用户\" class=\"cls-1\" d=\"M387.994,714.251a5.629,5.629,0,1,1,5.568-5.628A5.6,5.6,0,0,1,387.994,714.251Zm0-10.273a4.645,4.645,0,1,0,4.595,4.645A4.625,4.625,0,0,0,387.994,703.978ZM395.506,721a0.489,0.489,0,0,1-.486-0.492c0-3.45-3.152-6.257-7.026-6.257s-7.025,2.807-7.025,6.257a0.487,0.487,0,1,1-.973,0c0-3.992,3.589-7.24,8-7.24s8,3.248,8,7.24A0.489,0.489,0,0,1,395.506,721Z\" transform=\"translate(-380 -703)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user.svg
// module id = VdD3
// module chunks = 127